var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCategoryRelevancyFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4621 11H9.96214C9.59809 11 9.09719 10.8117 8.68285 10.4404C8.27764 10.0772 8.00025 9.5801 8.00023 9.00098C8.00023 8.41209 8.26002 7.9388 8.62914 7.59277C9.00567 7.23991 9.47117 7.04379 9.81859 7.00684L9.98558 6.99902L10.4621 6.97656V3.42871C10.4621 3.1892 10.6542 3 10.885 3H16.0764L16.1614 3.00879C16.3528 3.04838 16.5002 3.21942 16.5002 3.42871V14.5713C16.5002 14.8105 16.3074 14.9999 16.0764 15H10.885C10.6542 15 10.4621 14.8108 10.4621 14.5713V11Z",
    fill: "#9A9AC0",
    stroke: "#030362"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.92285 3H8.11523C8.34607 3.00001 8.53906 3.18922 8.53906 3.42871V5.77832C8.08836 5.91776 7.56744 6.17353 7.11426 6.56738C6.49936 7.10182 6 7.90266 6 9C6 10.0974 6.49929 10.8984 7.11426 11.4326C7.56733 11.8261 8.08858 12.0804 8.53906 12.2197V14.5713C8.53906 14.8108 8.34607 15 8.11523 15H1.92285C1.69204 14.9997 1.5 14.8104 1.5 14.5713V3.42871L1.50879 3.3418C1.54294 3.17316 1.67455 3.04266 1.83887 3.00879L1.92285 3Z",
    fill: "#030362",
    stroke: "#030362"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoryRelevancyFilled);
export default __webpack_public_path__ + "static/media/category-relevancy-filled.d7b2647a9ef476be14ee9109465f199a.svg";
export { ForwardRef as ReactComponent };